import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { callApi, formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import { MdCall, MdCheckCircle, MdEmail, MdLocationPin, MdSearch, MdWhatsapp } from "react-icons/md";
import { AiFillWechat } from "react-icons/ai";
import logo from '../assets/logo.png'
import logo_icon from '../assets/logo_icon.png'

export default function DonateContent(props) {

  const appContext = useContext(AppContext);

  /* Place states here */
  const [ ready, setReady ] = useState(false);
  const [loading, setLoading] = useState(false);

  const [fullname, setFullname] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [description, setDescription] = useState('');
  const [opSuccessful, setOpSuccessful] = useState(false);

  async function init() {
    //run initializations here
    setReady(false);
    //..
    
    setReady(true);
  }


  async function submit() {
    if(fullname && fullname.trim().length > 0) {
      if((phone && phone.trim().length > 0) || (email && email.trim().length > 0)) {
        if(description && description.trim().length > 0) {
          setLoading(true);
          await callApi(
            'create-partnership-request',
            {
              fullname,
              phone,
              email,
              description,
            }
          ).then(response => {
            if(response.status === 1) {
              setOpSuccessful(true);
              appContext.tellMessage("Successful");
            } else {
              appContext.tellError(response.msg);
            }
          })
          setLoading(false);
        } else {
          appContext.tellError("Invalid description");
        }
      } else {
        appContext.tellError("Provide atleast email or phone, or both");
      }
    } else {
      appContext.tellError("Invalid fullname");
    }
  }

  useEffect(() => {
    init();
  }, [ ]);

  useEffect(() => {
    appContext.setShowOverlayLoader(loading);

    return () => {
      appContext.setShowOverlayLoader(false);
    }
  }, [ loading ])

  if(ready) {
    return (
      <div 
        className="MainBodySection"
        style={{
          paddingBottom: "50px",
          paddingTop: "50px"
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h6
                className="main-section-title"
              >
                Partner With Us
                <span
                  style={{
                    display: "block",
                    borderBottom: "3px solid var(--secondaryColor)",
                    width: "50px",
                    marginTop: "10px"
                  }}
                >

                </span>
              </h6>
            </div>

            <div className="col-md-12 bg-primary">
              <div 
                className="text-center"
                style={{
                  padding: "30px",
                }}
              >
                <img
                  src={logo_icon}
                  style={{
                    width: "100px"
                  }}
                />

                <br/>
                <img
                  src={logo}
                  style={{
                    width: "250px"
                  }}
                />
              </div>
            </div>

            <div className="col-md-12">
              
              <h6
                className="font-semi-bold mt-5 mb-5 text-center"
                style={{
                  fontSize: "24px",
                }}
              >
                Fill in the form below if you want to become our partner and we'll get back to you shortly
              </h6>
              
              <div className="card">
                {
                  (opSuccessful) ?
                  <div className="card-body text-center">
                    <h6
                      style={{
                        fontSize: "28px",
                        padding: "20px"
                      }}
                      className="font-light"
                    >
                      <MdCheckCircle className="text-primary" size={96}/>

                      <br/>

                      Thanks, we'll contact you soon!
                    </h6>
                  </div>
                  :
                  <div className="card-body">
                  
                    <div className="mb-3 mt-3">
                      <label className="form-label">Fullname</label>
                      <input
                        className="form-control"
                        value={fullname}
                        onChange={(e) => setFullname(e.target.value)}
                      />
                    </div>

                    <div className="mb-3 mt-3">
                      <label className="form-label">Phone</label>
                      <input
                        className="form-control"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                      />
                    </div>

                    <div className="mb-3 mt-3">
                      <label className="form-label">Email</label>
                      <input
                        className="form-control"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>

                    <div className="mb-3 mt-3">
                      <label className="form-label">Description</label>
                      <textarea
                        className="form-control"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                      />
                    </div>

                    <div className="mb-3 mt-3">
                      <button
                        className="btn btn-block btn-padded btn-rounded btn-primary"
                        onClick={submit}
                      >
                        SUBMIT
                      </button>
                    </div>


                  </div>
                }
              </div>
            </div>

          </div>
        </div>
      </div>
    )
  } else {
    return (
      <div 
        className="container mSupportLoading"
      >
        {getInlineLoader()}
      </div>
    );
  }

  
}